<div [ngClass]="{
    'search-input-container': true,
    'disabled': disabled
  }">
    <mat-icon *ngIf="!hasText">search</mat-icon>
    <a
        (click)="clearText()"
        *ngIf="hasText"
    >
        <mat-icon>clear</mat-icon>
    </a>
    <input
        [placeholder]="placeholder"
        autocomplete="off"
        [ngClass]="{
      'search-input': true,
      'disabled': disabled
    }"
        type="text"
        #searchText
        (input)="search(searchText.value)"
        [(ngModel)]="searchInput"
        [disabled]="disabled"
    >
</div>
